<template>
  <div>
    <p class="title">AGENDA
      <button type="button" class="close text-white" aria-label="Close" @click.prevent="$modal.hide('modalAgenda')" >
        <span aria-hidden="true">&times;</span>
      </button>
    </p>

    <div class="container-fluid">
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th class="w-25">Nome</th>
            <th class="text-center">Data</th>
            <th class="text-center">Hora</th>
            <th class="text-center">Observação</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="c in schedules" :key="c.id" @dblclick="editSchedule(c)">
            <td class="align-middle">{{c.contato | firstAndLastName }}</td>
            <td class="text-center align-middle">{{c.data | dateISOFormat }}</td>
            <td class="text-center align-middle">{{c.hora}}</td>
            <td class="align-middle" style="max-width=150px !important;"><pre>{{c.obs}}</pre></td>
            <td class="text-center align-middle">
              <button class="btn btn-sm btn-outline-info" @click="editSchedule(c)"><i class="fa fa-pencil"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: "ScheduleList",

  props: {
    schedules: {
      type: Array,
      required: true,
      default: []
    }
  },

  methods: {
    editSchedule(schedule) {
      this.$emit("editSchedule", schedule);
    }
  }
};
</script>



// WEBPACK FOOTER //
// ScheduleList.vue?0a5af467